import { CheckoutSteps } from '../util/enums';

export const sortOptions = [
  { value: 'createdAt', label: 'Newest' },
  { value: '-createdAt', label: 'Oldest' },
  { value: '-price', label: 'Lowest Price' },
  { value: 'price', label: 'Highest Price' },
];

export const searchCategoryOptions = [
  { name: 'Nike', icon: 'offerIcon', key: 'nike' },
  { name: 'Adidas', icon: 'offerIcon', key: 'adidas' },
  { name: 'Puma', icon: 'offerIcon', key: 'puma' },
  { name: 'Skechers', icon: 'offerIcon', key: 'skechers' },
  { name: 'Mizuno', icon: 'offerIcon', key: 'mizuno' },
  { name: 'New Balance', icon: 'offerIcon', key: 'newbalance' },
  { name: 'Under Armour', icon: 'offerIcon', key: 'underarmour' },
];

export const brandModels = [
  {
    brand: 'Nike',
    models: ['Mercurial Vapor', 'Mercurial Superfly', 'Tiempo', 'Phantom', 'Premier'],
  },
  {
    brand: 'Adidas',
    models: ['Predator', 'F50', 'Copa', 'X', '11Pro'],
  },
  {
    brand: 'Puma',
    models: ['One', 'Future', 'King', 'Ultra'],
  },
  {
    brand: 'Skechers',
    models: ['Razor', 'Pulse', 'Glide', 'Spark'],
  },
  {
    brand: 'Mizuno',
    models: ['Rebula', 'Morelia', 'Wave', 'Neo'],
  },
  {
    brand: 'New Balance',
    models: ['Furon', 'Tekela', 'Audazo', '442'],
  },
  {
    brand: 'Under Armour',
    models: ['Magnetico', 'Clone', 'Spotlight', 'Blur'],
  },
  {
    brand: 'Other',
    models: ['Generic', 'Custom'],
  },
];
export const weightUnitEnum = Object.freeze(
  [
    { value: 'g', label: 'g' },
    { value: 'kg', label: 'kg' },
    { value: 'lb', label: 'lb' },
    { value: 'oz', label: 'oz' },
  ].map(Object.freeze)
);

export const distanceUnitOptions = Object.freeze(
  [
    { value: 'cm', label: 'Centimeters' },
    { value: 'in', label: 'Inches' },
    { value: 'ft', label: 'Feet' },
    { value: 'm', label: 'Meters' },
    { value: 'mm', label: 'Millimeters' },
    { value: 'yd', label: 'Yards' },
  ].map(Object.freeze)
);

export const checkoutStepsTabs = [
  { step: CheckoutSteps.SHIPPING, label: 'Your Information' },
  { step: CheckoutSteps.CARRIERS, label: 'Shipping Method' },
  { step: CheckoutSteps.PAYMENT, label: 'Payment' },
];
